/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getManyBasePrintingMaterialControllerPrintingMaterial } from '../fn/printing-material/get-many-base-printing-material-controller-printing-material';
import { GetManyBasePrintingMaterialControllerPrintingMaterial$Params } from '../fn/printing-material/get-many-base-printing-material-controller-printing-material';
import { GetManyPrintingMaterialResponseDto } from '../models/get-many-printing-material-response-dto';
import { getOneBasePrintingMaterialControllerPrintingMaterial } from '../fn/printing-material/get-one-base-printing-material-controller-printing-material';
import { GetOneBasePrintingMaterialControllerPrintingMaterial$Params } from '../fn/printing-material/get-one-base-printing-material-controller-printing-material';
import { PrintingMaterial } from '../models/printing-material';

@Injectable({ providedIn: 'root' })
export class PrintingMaterialApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getManyBasePrintingMaterialControllerPrintingMaterial()` */
  static readonly GetManyBasePrintingMaterialControllerPrintingMaterialPath = '/api/printing-materials';

  /**
   * Retrieve multiple PrintingMaterials.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getManyBasePrintingMaterialControllerPrintingMaterial()` instead.
   *
   * This method doesn't expect any request body.
   */
  getManyBasePrintingMaterialControllerPrintingMaterial$Response(params?: GetManyBasePrintingMaterialControllerPrintingMaterial$Params, context?: HttpContext): Observable<StrictHttpResponse<GetManyPrintingMaterialResponseDto>> {
    const obs = getManyBasePrintingMaterialControllerPrintingMaterial(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve multiple PrintingMaterials.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getManyBasePrintingMaterialControllerPrintingMaterial$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getManyBasePrintingMaterialControllerPrintingMaterial(params?: GetManyBasePrintingMaterialControllerPrintingMaterial$Params, context?: HttpContext): Observable<GetManyPrintingMaterialResponseDto> {
    const resp = this.getManyBasePrintingMaterialControllerPrintingMaterial$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<GetManyPrintingMaterialResponseDto>): GetManyPrintingMaterialResponseDto => r.body)
    );
  }

  /** Path part for operation `getOneBasePrintingMaterialControllerPrintingMaterial()` */
  static readonly GetOneBasePrintingMaterialControllerPrintingMaterialPath = '/api/printing-materials/{id}';

  /**
   * Retrieve a single PrintingMaterial.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOneBasePrintingMaterialControllerPrintingMaterial()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOneBasePrintingMaterialControllerPrintingMaterial$Response(params: GetOneBasePrintingMaterialControllerPrintingMaterial$Params, context?: HttpContext): Observable<StrictHttpResponse<PrintingMaterial>> {
    const obs = getOneBasePrintingMaterialControllerPrintingMaterial(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve a single PrintingMaterial.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOneBasePrintingMaterialControllerPrintingMaterial$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOneBasePrintingMaterialControllerPrintingMaterial(params: GetOneBasePrintingMaterialControllerPrintingMaterial$Params, context?: HttpContext): Observable<PrintingMaterial> {
    const resp = this.getOneBasePrintingMaterialControllerPrintingMaterial$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PrintingMaterial>): PrintingMaterial => r.body)
    );
  }

}
